import React from 'react';

function CspLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="146"
      height="146"
      viewBox="0 0 146 146"
    >
      <defs>
        <filter
          id="Ellipse_1312"
          x="0"
          y="0"
          width="146"
          height="146"
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation="10" result="blur" />
          <feFlood floodColor="#1e2769" floodOpacity="0.09" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_67375" data-name="Group 67375" transform="translate(-56 -39)">
        <g transform="matrix(1, 0, 0, 1, 56, 39)" filter="url(#Ellipse_1312)">
          <circle
            id="Ellipse_1312-2"
            data-name="Ellipse 1312"
            cx="43"
            cy="43"
            r="43"
            transform="translate(30 30)"
            fill="#fcfcff"
          />
        </g>
        <g id="Group_67368" data-name="Group 67368" transform="translate(94.064 98.595)">
          <path
            id="Path_70134"
            data-name="Path 70134"
            d="M-18263.508-8845.536v-7.588a7.972,7.972,0,0,1,.365-2.474,5.6,5.6,0,0,1,1.08-1.947,5.248,5.248,0,0,1,.943-.861,5.621,5.621,0,0,1,1.143-.613,6.755,6.755,0,0,1,1.342-.369,9.082,9.082,0,0,1,1.537-.122h6.646a1.783,1.783,0,0,0,1.428-.588,2.092,2.092,0,0,0,.5-1.39,2.181,2.181,0,0,0-.48-1.435,1.8,1.8,0,0,0-1.449-.654h-24.234l3.494-4.833h21.646a8,8,0,0,1,1.486.135,6.6,6.6,0,0,1,1.322.4,5.953,5.953,0,0,1,1.156.673,6.36,6.36,0,0,1,1,.942,6.746,6.746,0,0,1,.719,1.027,6.939,6.939,0,0,1,.516,1.137,8.019,8.019,0,0,1,.412,2.606,7.949,7.949,0,0,1-.412,2.591,6.956,6.956,0,0,1-.516,1.135,6.827,6.827,0,0,1-.719,1.025,6.371,6.371,0,0,1-1,.95,5.873,5.873,0,0,1-1.156.677,6.361,6.361,0,0,1-1.322.407,8,8,0,0,1-1.486.135h-5.223a3.243,3.243,0,0,0-2.873,1.256,3.783,3.783,0,0,0-.586,2.154v5.62Zm-9.879,0h-30.533a9.256,9.256,0,0,1-2.047-.22,7.656,7.656,0,0,1-1.824-.656,7.668,7.668,0,0,1-1.588-1.094,9.1,9.1,0,0,1-1.373-1.531,11.5,11.5,0,0,1-.984-1.662,12.338,12.338,0,0,1-.7-1.849,13.258,13.258,0,0,1-.418-2.027,16.452,16.452,0,0,1-.143-2.211,17.161,17.161,0,0,1,.143-2.254,14.034,14.034,0,0,1,.432-2.08,12.845,12.845,0,0,1,.713-1.906,12.092,12.092,0,0,1,1-1.732,10.166,10.166,0,0,1,1.375-1.6,7.759,7.759,0,0,1,1.59-1.141,7.489,7.489,0,0,1,1.8-.684,8.733,8.733,0,0,1,2.023-.229h13.875s-.311.291-.693.729a9.885,9.885,0,0,0-1.191,1.633,7.209,7.209,0,0,0-.65,1.688,6.341,6.341,0,0,0-.146.783h-10.291a3.528,3.528,0,0,0-3.154,1.983,8.745,8.745,0,0,0-1.025,4.4,9.327,9.327,0,0,0,1.068,4.6,3.508,3.508,0,0,0,3.111,2.1l7.391.092h21.354a1.571,1.571,0,0,0,1.326-.645,2.441,2.441,0,0,0,.484-1.491,2.259,2.259,0,0,0-.463-1.432,1.611,1.611,0,0,0-1.348-.592h-6.93l3.574-4.943h4.242a7.746,7.746,0,0,1,1.473.135,6.243,6.243,0,0,1,1.314.408,5.654,5.654,0,0,1,1.146.679,6.241,6.241,0,0,1,.986.951,7.1,7.1,0,0,1,.711,1.029,7.254,7.254,0,0,1,.51,1.147,8.237,8.237,0,0,1,.406,2.636,8.206,8.206,0,0,1-.406,2.628,7.3,7.3,0,0,1-.51,1.148,7.131,7.131,0,0,1-.711,1.038,6.2,6.2,0,0,1-.986.952,5.8,5.8,0,0,1-1.146.681,6.354,6.354,0,0,1-1.314.405A7.743,7.743,0,0,1-18273.387-8845.536Z"
            transform="translate(18313 8872.538)"
            fill="#2571f0"
          />
          <path
            id="Path_70138"
            data-name="Path 70138"
            d="M-19208.977-9501.257h0a5.651,5.651,0,0,1-3.18-2.207,7.272,7.272,0,0,1-1.309-3.691.008.008,0,0,0,0-.006c-.008-.1-.027-.354-.027-.676,0-.226.008-.534.027-.868,0-.007,0-.011,0-.014v0a7.253,7.253,0,0,1,.84-3.025,6.437,6.437,0,0,1,2.059-2.281,5.944,5.944,0,0,1,3.488-.891h4.5a22.1,22.1,0,0,1,2.953-3.028,8.986,8.986,0,0,1,1.092-.786,1.6,1.6,0,0,1,.672-.269.177.177,0,0,1,.119.035c.139.1.076.388-.2.931-.264.513-.7,1.219-1.246,2.111l-.02.036c-.215.346-.455.738-.707,1.148h0l-9.059,13.485Zm2.83-8.79a1.84,1.84,0,0,0-1.527.541,2.4,2.4,0,0,0-.527,1.538,2.422,2.422,0,0,0,.33,1.219h0l.5-.739a1.788,1.788,0,0,1-.068-.479,1.735,1.735,0,0,1,.354-1.084,1.152,1.152,0,0,1,.941-.282h.016l.48-.713Z"
            transform="translate(19238.365 9519.003)"
            fill="#fb0"
          />
        </g>
      </g>
    </svg>
  );
}

export default CspLogo;
